<template>
    <number-flow ref="numberFlow" />
</template>

<script>
import 'number-flow';

export default {
    name: 'AnimatedQuantity',
    props: {
        value: {
            type: Number,
            required: true,
            default: 0
        },
        duration: {
            type: Number,
            required: false,
            default: 300
        }
    },
    mounted() {
        this.configureNumberFlow();
        this.updateValue();
    },
    watch: {
        value() {
            this.updateValue();
        },
        duration() {
            this.configureNumberFlow();
        }
    },
    methods: {
        configureNumberFlow() {
            this.$nextTick(() => {
                const el = this.$refs.numberFlow;
                if (el) {
                    el.format = { maximumFractionDigits: 0 };
                    el.transformTiming = {
                        duration: this.duration,
                        easing: 'ease-out'
                    };
                    el.spinTiming = {
                        duration: this.duration,
                        easing: 'ease-out'
                    };
                    el.opacityTiming = {
                        duration: this.duration / 2,
                        easing: 'ease-out'
                    };
                }
            });
        },
        updateValue() {
            this.$nextTick(() => {
                const el = this.$refs.numberFlow;
                if (el) {
                    el.update(this.value);
                }
            });
        }
    }
};
</script>
